<div class="mt-2 px-4 pb-2 h-100" fxLayout="column" *ngIf="selectedProjectArray">
    <div fxLayout="row" fxFlex="1 1 11%" fxLayoutAlign="space-between top" class="sen-project-details-container">
        <div class="sen-project-details-block sen-project-name-cont">
            <h4 class="font-weight-bold sen-project-overflow-break" title="{{selectedProjectArray.name}}">
                {{selectedProjectArray.name | truncate: 30}}
            </h4>
            <p class="sen-cyan-blue-color font-weight-bold">{{translate.getLng('UPDATED_DATE_STRING')}} :
                {{selectedProjectArray.updated}}</p>
        </div>
        <div class="sen-fs10 font-weight-bold sen-project-details-block">
            <table>
                <tr>
                    <td class="sen-direction-row-colomn"><img src="{{imagePath.windIcon}}" width="12"> &nbsp; <span>{{translate.getLng('WINDZONE')}}</span></td>
                    <td class="px-2">:</td>
                    <td>{{selectedProjectArray.windZone}}</td>
                </tr>
                <tr>
                    <td class="sen-direction-row-colomn"><img src="{{imagePath.snowIcon}}" width="12"> &nbsp; <span>{{translate.getLng('SNOWZONE')}}</span></td>
                    <td class="px-2">:</td>
                    <td>{{selectedProjectArray.snowZone}}</td>
                </tr>
                <tr>
                    <td class="sen-direction-row-colomn"><img src="{{imagePath.terrainIcon}}" width="12"> &nbsp; <span>{{translate.getLng('TERRAIN_CAT')}}</span></td>
                    <td class="px-2">:</td>
                    <td>{{globalF.getInt(selectedProjectArray.terrainCategory) + 1}}</td>
                </tr>
            </table>
        </div>
        <div *ngIf="projectModulname" class="sen-fs10 sen-project-details-block">
            <label><b>{{translate.getLng('PROJECT_PANEL')}}</b></label> : <span
                title="{{projectModulname}}">{{projectModulname | truncate:20}}</span>
        </div>
        <div class="sen-fs10 sen-project-address-display sen-project-details-block">
            <label class="set-blue-color">{{translate.getLng('PROJECT_LOCATION')}}</label>
            <p>{{selectedProjectArray.address.full}} </p>
        </div>
        <div class="sen-project-details-block sen-project-view-ipad">
            <button (click)="editProject()" class="sen-primary-icon bg-white" mat-fab>
                <mat-icon class="mb-1">edit</mat-icon>
            </button>
            <button (click)="copyProject()" class="sen-primary-icon bg-white" mat-fab>
                <mat-icon class="mb-1">content_copy</mat-icon>
            </button>
            <button (click)="deleteProject()" class="sen-primary-icon bg-white" mat-fab>
                <mat-icon class="mb-1">delete</mat-icon>
            </button>
        </div>
    </div>
    <mat-divider class="mt-1"></mat-divider>
    <div fxLayout="row" fxFlex="1 1 auto" fxLayoutAlign="space-between top" class="overflow-hidden mt-2"
        *ngIf="selectedProjectArray">
        <div fxFlex=" 1 1 48%" fxLayout="column" class="overflow-hidden">
            <h4 class="mb-2"><span class="d-inline-block pt-2">{{translate.getLng('ROOF_PLANS')}}</span> <span
                    class="float-right">
                    <button (click)="newPlanCreation()" class="sen-secondary-icon bg-white" mat-fab>
                        <mat-icon class="mb-2">add</mat-icon>
                    </button>
                    <!-- commented out since imported plan metadata should match with project metadata -->
                    <!-- <sen-app-import-plan-button>
                    </sen-app-import-plan-button> -->
                    <button (click)="copyPlan()" class="sen-secondary-icon bg-white" [disabled]="!selectedRoofPlan"
                        mat-fab>
                        <mat-icon class="mb-2">content_copy</mat-icon>
                    </button>
                    <button class="sen-secondary-icon bg-white" (click)="deletePlan()" [disabled]="!selectedRoofPlan"
                        mat-fab>
                        <mat-icon class="mb-2">delete</mat-icon>
                    </button>
                </span></h4>
            <ng-template #createPlanButton>
                <button mat-raised-button (click)="navNext()" color="primary" class="mx-auto d-block px-3 mt-4">
                    <mat-icon>add</mat-icon> {{translate.getLng('CREATE_NEW_PLAN')}}
                </button>
            </ng-template>
            <div class="pr-2 pb-2 overflow-auto" fxFlex="1 1 auto"
                *ngIf="selectedProjectArray.roofPlans.length; else createPlanButton">
                <ng-container *ngFor="let plan of selectedProjectArray.roofPlans">
                    <mat-card class="p-2 mt-2 sen-light-blue-bg"
                        [ngClass]="plan.panelID == selectedProjectArray.panelID ? 'sen-light-blue-bg' : 'sen-info-color-bg sen-cyan-blue-color'"
                        fxLayout="row" fxLayoutAlign="space-between center">
                        <mat-checkbox (click)="setSelectedRoofPlan(plan)"
                            [checked]="selectedRoofPlan && plan.id == selectedRoofPlan.id" class="ml-3" fxFlex="1 1 8%">
                        </mat-checkbox>
                        <div fxFlex="1 1 auto">
                            <p class="mb-0" title="{{plan.name}}">{{plan.name | truncate:20}}
                                <mat-icon matTooltipClass="sen-snackbar-color"
                                    matTooltip="{{translate.getLng('INVALID_PLAN_MESSAGE')}}"
                                    class="sen-fs16 sen-valign-sub" *ngIf="plan.invalid" color="invalid">
                                    warning</mat-icon>


                            </p>
                            <label class="sen-fs10">{{translate.getLng('UPDATED_DATE_STRING')}} :
                                {{plan.updated}}</label>
                        </div>
                        <p class="mb-0 sen-fs10" fxFlex="1 1 38%">{{translate.getLng('ID')}} :
                            {{plan.id}}<br>
                            <span title="{{plan.panelName}}">{{translate.getLng('PANEL')}}:
                                {{plan.panelName | truncate:15}}</span>&nbsp;<mat-icon
                                matTooltipClass="sen-snackbar-color"
                                matTooltip="{{translate.getLng('MISMATCH_PLAN_MESSAGE')}}"
                                class="sen-fs12 sen-valign-sub" *ngIf="plan.panelID != selectedProjectArray.panelID"
                                color="invalid">
                                warning</mat-icon>
                        </p>
                        <div fxFlex="1 1 10%">
                            <button (click)="getPlanParams(plan)" class="sen-secondary-icon bg-white" mat-fab>
                                <mat-icon class="mb-2">keyboard_arrow_right</mat-icon>
                            </button>
                            <!-- <button (click)="exportRoofPlan(plan)" class="sen-secondary-icon bg-white" mat-fab>
                                <mat-icon class="mb-2">unarchive</mat-icon>
                            </button> -->
                        </div>
                    </mat-card>
                </ng-container>
            </div>
        </div>
        <mat-divider class="ml-2 mr-3" [vertical]="true"></mat-divider>
        <div fxFlex="1 1 48%" fxLayout="column" class="overflow-hidden">
            <h4 class="mb-2"><span class="d-inline-block pt-2">{{translate.getLng('INVERTER') }}<mat-icon matTooltipClass="sen-snackbar-color"
                        matTooltip="{{translate.getLng('INVALID_INVERTER_PLAN_MESSAGE')}}"
                        class="sen-fs16 sen-valign-sub h-auto" *ngIf="selectedProjectArray.inverterPlan?.invalid"
                        color="invalid">
                        warning</mat-icon></span>
                <span class="float-right">
                    <button *ngIf="!selectedProjectArray.inverterPlan" [disabled]="!checkAllPlansValid()"
                        (click)="addInverter()" class="sen-secondary-icon bg-white" mat-fab>
                        <mat-icon class="mb-2">add</mat-icon>
                    </button>
                    <button class="sen-secondary-icon bg-white" *ngIf="selectedProjectArray.inverterPlan"
                        (click)="getInverter()" [disabled]="!checkAllPlansValid()" mat-fab>
                        <mat-icon class="mb-2">edit</mat-icon>
                    </button>
                </span></h4>

            <div class="pr-2 pb-2 overflow-auto" fxFlex="1 1 auto">
                <ng-container *ngIf="selectedProjectArray.inverterPlan?.subGenerators">
                    <mat-card class="p-2 mt-2 sen-light-blue-bg" fxLayout="row" fxLayoutAlign="space-between center"
                        *ngFor="let g of selectedProjectArray.inverterPlan.subGenerators">
                        <div fxFlex="1 1 auto">
                            <p class="mb-0" title="{{g.name}}">{{g.name | truncate:30}}</p>
                            <label class="sen-fs10">{{g.inverterName}}</label>
                        </div>
                        <div fxFlex="1 1 40%">
                            <p class="mb-0">{{g.totalCapacity}}{{translate.getLng('UNIT_KWP')}}</p>
                            <label class="d-flex sen-fs10">{{g.stringCount}} {{translate.getLng('INV_STRING')}}
                                <mat-divider [vertical]="true" class="mx-2"></mat-divider> {{g.panelCount}}
                                {{translate.getLng('MODULES')}}</label>
                        </div>
                    </mat-card>
                </ng-container>
                <p *ngIf="!selectedProjectArray.roofPlans.length">{{translate.getLng('NO_PLAN_MESSAGE')}}</p>
                <ng-container *ngIf="!selectedProjectArray.inverterPlan && selectedProjectArray.roofPlans.length">
                    <button mat-raised-button (click)="addInverter()" color="primary" class="d-block mx-auto px-3 mt-4">
                        <mat-icon>add</mat-icon> {{translate.getLng('CREATE_NEW_INVERTER_PLAN')}}
                    </button>
                </ng-container>
            </div>
        </div>
    </div>
    <div fxFlex="1 1 30%" class="mt-2" *ngIf="selectedProjectArray?.address?.lat">
        <agm-map #agmMap class="h-100 w-100" [streetViewControl]="false" [disableDoubleClickZoom]="true"
            [mapTypeId]="'hybrid'" [zoom]="20" [latitude]="selectedProjectArray.address.lat"
            [longitude]="selectedProjectArray.address.lon" [fullscreenControl]="true">
            <agm-marker [latitude]="selectedProjectArray.address.lat" [longitude]="selectedProjectArray.address.lon">
                <agm-info-window [isOpen]="true">
                    <strong><span>{{translate.getLng('PROJECT_LOCATION')}}</span><br>
                        {{selectedProjectArray?.address?.full}} </strong>
                </agm-info-window>
            </agm-marker>
        </agm-map>
    </div>
</div>
